import { render, staticRenderFns } from "./scene20.vue?vue&type=template&id=228cdcec&scoped=true&"
import script from "./scene20.vue?vue&type=script&lang=ts&"
export * from "./scene20.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228cdcec",
  null
  
)

export default component.exports